import { styled } from '@linaria/react';

export const Wrapper = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	gap: var(--gap-m);
`;
